// extracted by mini-css-extract-plugin
export default {"menuBtn":"HamburgerMenu_menuBtn__A0YxW","menuBtnBurger":"HamburgerMenu_menuBtnBurger__abrv0","open":"HamburgerMenu_open__w83WE"};